export default __webpack_public_path__ + "static/media/22.016efc42.jpg";